import axios from 'axios';

// Get the API base URL dynamically at RUNTIME (not build time)
// This ensures the app works on ANY domain without rebuilding
export const getApiBaseUrl = () => {
  // In browser, ALWAYS use current origin for production deployments
  // This makes the app domain-agnostic and works on letwise.io, preview.emergentagent.com, etc.
  if (typeof window !== 'undefined' && window.location.origin) {
    const origin = window.location.origin;
    // Check if we're on a custom domain (not localhost)
    if (!origin.includes('localhost') && !origin.includes('127.0.0.1')) {
      return origin;
    }
  }
  // For local development, use env var or localhost fallback
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  return 'http://localhost:8000';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token AND workspace/org scope to requests
api.interceptors.request.use((config) => {
  // Add auth token (check both keys for backwards compatibility)
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add workspace/org scope from user data if available
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user.workspace_id) {
        config.headers['X-Workspace-ID'] = user.workspace_id;
      }
      if (user.org_id) {
        config.headers['X-Org-ID'] = user.org_id;
      }
    } catch (e) {
      // Ignore JSON parse errors
    }
  }
  
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login on 401 if NOT on login/register endpoints
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                          error.config?.url?.includes('/auth/register');
    
    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Check if we have a token (means session expired)
      const hadToken = localStorage.getItem('access_token');
      if (hadToken) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;